import { BuyingInfluence } from '../../api/models';
import {
  createAction,
  createActionWithPayload,
  IAction,
  IActionWithPayload,
} from '../utils';

const ACTION_LOAD_BUYING_INFLUENCE_REQUEST =
  'ENTITIES/LOAD_BUYING_INFLUENCE_REQUEST';
const ACTION_LOAD_BUYING_INFLUENCE_SUCCESS =
  'INTENT/LOAD_BUYING_INFLUENCE_SUCCESS';
const ACTION_LOAD_BUYING_INFLUENCE_ERROR = 'INTENT/LOAD_BUYING_INFLUENCE_ERROR';

export interface BuyingInfluenceState {
  buyingInfluence: BuyingInfluence[];
  isLoading?: boolean;
  isLoaded?: boolean;
}

const initialState: BuyingInfluenceState = {
  buyingInfluence: [],
  isLoaded: false,
  isLoading: false,
};

type BuyingInfluenceRequestActionType = IAction<
  typeof ACTION_LOAD_BUYING_INFLUENCE_REQUEST
>;

type BuyingInfluenceSuccessActionType = IActionWithPayload<
  typeof ACTION_LOAD_BUYING_INFLUENCE_SUCCESS,
  BuyingInfluence[]
>;

type BuyingInfluenceErrorActionType = IAction<
  typeof ACTION_LOAD_BUYING_INFLUENCE_ERROR
>;

type Actions =
  | BuyingInfluenceRequestActionType
  | BuyingInfluenceSuccessActionType
  | BuyingInfluenceErrorActionType;

export const loadBuyingInfluenceRequestAction = (): BuyingInfluenceRequestActionType => {
  return createAction(ACTION_LOAD_BUYING_INFLUENCE_REQUEST);
};

export const loadBuyingInfluenceSuccessAction = (
  data: BuyingInfluence[]
): BuyingInfluenceSuccessActionType => {
  return createActionWithPayload(ACTION_LOAD_BUYING_INFLUENCE_SUCCESS, data);
};

export const loadBuyingInfluenceErrorAction = (): BuyingInfluenceErrorActionType => {
  return createAction(ACTION_LOAD_BUYING_INFLUENCE_ERROR);
};

// reducer
export const buyingInfluenceReducer = (
  state: BuyingInfluenceState = initialState,
  action: Actions
): BuyingInfluenceState => {
  switch (action.type) {
    case ACTION_LOAD_BUYING_INFLUENCE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case ACTION_LOAD_BUYING_INFLUENCE_ERROR:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    case ACTION_LOAD_BUYING_INFLUENCE_SUCCESS:
      return {
        ...state,
        buyingInfluence: action.payload,
        isLoading: false,
        isLoaded: true,
      };
    default:
      return state;
  }
};
